import React, {Component} from 'react';
import {Col, FormGroup} from 'reactstrap';
import NewTemplate from 'template/components/NewTemplate';
import TemplateCategorySearch from 'template/components/TemplateCategorySearch';
import NewTemplateCategory from 'template/components/NewTemplateCategory';


export default class TemplateCategoryControls extends Component {
    render() {
        return (
            <FormGroup row className="mt-3">
                <Col sm={3}>
                    <TemplateCategorySearch/>
                </Col>
                <Col sm={6}>
                    <NewTemplateCategory/>
                    <NewTemplate/>
                </Col>
            </FormGroup>
        )
    }
}
